<script setup lang="ts">
import { HTMLAttributes, ref } from 'vue'
import { useVModel } from '@vueuse/core'
import { cn } from '@/lib/utils'
import { type InputVariants, inputVariants } from '.'

const props = defineProps<{
  defaultValue?: string | number
  modelValue?: string | number
  size?: InputVariants['size']
  class?: HTMLAttributes['class']
}>()

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void
}>()

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
})

const input = ref<InstanceType<typeof HTMLInputElement> | null>(null)

defineExpose({
  input,
})
</script>

<template>
  <input
    ref="input"
    v-model="modelValue"
    :class="cn(inputVariants({ size }), props.class)" />
</template>
